import { FC, memo, useCallback } from 'react';
import { amplitudeService } from 'services/amplitude';
import { getPath, Path } from 'urlBuilder';

import { CollapseSection } from '../CollapseSection/CollapseSection';
import { messages } from './ConnectAccountingSystem.messages';
import { ConnectAccountingSystemProps } from './ConnectAccountingSystem.types';

export const ConnectAccountingSystem: FC<ConnectAccountingSystemProps> = memo((props) => {
    const { collapsed, complete, number, companyId, profileId } = props;

    const handleButtonClick = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on connect GL', {
            user_id: profileId,
            org_id: companyId,
        });
    }, [companyId, profileId]);

    return (
        <CollapseSection
            collapsed={collapsed}
            complete={complete}
            number={number}
            title={messages.title}
            buttonText={messages.buttonText}
            buttonLink={getPath(Path.companyWorkflows, companyId)}
            onButtonClick={handleButtonClick}
        >
            {messages.description}
        </CollapseSection>
    );
});

ConnectAccountingSystem.displayName = 'ConnectAccountingSystem';
